import Input, { type Props } from './Input';

const TelInput = (props: Props) => {
    return <Input type="tel" {...props} />;
};

export default TelInput;
